'use client';

import a__default from "react";
import { Text } from "../../atoms/Text/Text.js";
import { wrapper } from "./RequiredIndicator.css.js";
import { requiredLabel } from "./RequiredIndicator.data.js";
function RequiredIndicator({
  disabled = false,
  hidden = false,
  a11yAnnounce = true
}) {
  const textColor = disabled ? "onLight.disabled.muted" : "action.warning.darkest";
  let textJsx = /* @__PURE__ */ a__default.createElement(Text, { className: wrapper, color: textColor, "aria-hidden": true }, "*");
  if (hidden) textJsx = null;
  return /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, textJsx, a11yAnnounce && /* @__PURE__ */ a__default.createElement(Text, { visuallyHidden: true }, requiredLabel));
}
export {
  RequiredIndicator
};
